import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLazyGetProjectUserSlicedLeaderboardQuery } from '../../modules/missionControl/api'
import { setUserSlicedLeaderboard } from '../../modules/missionControl/slice'
import { selectUserSlicedLeaderboard } from '../../modules/missionControl/selectors'

function useUserSlicedLeaderboard(projectId?: number) {
  const dispatch = useDispatch()
  const userSlicedLeaderboard = useSelector(selectUserSlicedLeaderboard)
  const [fetchUserSlicedLeaderboard, { isLoading, isFetching }] =
    useLazyGetProjectUserSlicedLeaderboardQuery()

  const handleFetchUserSlicedLeaderboard = useCallback(
    async ({ projectId }: { projectId: number }) => {
      try {
        const { userSlicedLeaderboard } = await fetchUserSlicedLeaderboard({
          projectId,
        }).unwrap()
        dispatch(setUserSlicedLeaderboard(userSlicedLeaderboard))
      } catch (error) {
        console.error('Error fetching user sliced leaderboard', error)
      }
    },
    [dispatch, fetchUserSlicedLeaderboard],
  )

  const hasUserSlicedLeaderboardInStore = !!userSlicedLeaderboard
  useEffect(() => {
    if (!hasUserSlicedLeaderboardInStore && projectId)
      handleFetchUserSlicedLeaderboard({ projectId })
  }, [
    handleFetchUserSlicedLeaderboard,
    hasUserSlicedLeaderboardInStore,
    projectId,
  ])

  return {
    userSlicedLeaderboard,
    loading: isLoading || isFetching,
    handleFetchUserSlicedLeaderboard,
  }
}

export default useUserSlicedLeaderboard
